<template>
    <v-card outlined v-bind="{ loading }" :href="`/lectures/${value._id}`" target="_blank">
        <v-img :src="value.thumb?.src" :aspect-ratio="16 / 9" class="grey-f7" content-class="d-flex flex-column">
            <template #placeholder>
                <v-layout justify-center align-center fill-height>
                    <v-icon x-large color="grey lighten-4">mdi-image-broken-variant</v-icon>
                </v-layout>
            </template>
            <v-col>
                <v-row justify="end" class="ma-n4">
                    <v-col cols="auto" class="pa-4">
                        <lecture-form v-bind="{ value }" v-on="{ search }" @input="updateItem">
                            <template #activator="{ attrs, on }">
                                <v-btn dark small icon class="secondary" v-bind="attrs" v-on="on" @click.prevent.stop>
                                    <v-icon small>mdi-pencil</v-icon>
                                </v-btn>
                            </template>
                        </lecture-form>
                    </v-col>
                    <v-col cols="auto" class="pa-4">
                        <v-btn dark small icon class="red darken-4" @click.prevent.stop="remove">
                            <v-icon small>mdi-delete</v-icon>
                        </v-btn>
                    </v-col>
                </v-row>
            </v-col>
            <v-col cols="auto">
                <item-badges v-bind="{ value }" />
            </v-col>
        </v-img>
        <v-divider />
        <v-row class="ma-0" align="center">
            <v-col class="pa-16 font-size-18 font-weight-bold text-truncate">
                {{ value?.subject }}
            </v-col>
            <v-col cols="auto" class="pa-16">
                <v-chip small outlined>{{ value?.meta?.watcherCount?.format?.() }}명 참여</v-chip>
            </v-col>
        </v-row>
    </v-card>
</template>

<script>
import { initLecture } from "@/store/lecture";

import ItemBadges from "./item/item-badges.vue";
import LectureForm from "@/components/dashboard/company/lecture/form/lecture-form.vue";

export default {
    components: {
        ItemBadges,
        LectureForm,
    },
    props: {
        value: { type: Object, default: initLecture },
        loading: { type: Boolean, default: false },
    },
    methods: {
        search() {
            this.$emit("search");
        },
        remove() {
            const message = `"${this.value.subject}" 영상을 정말 삭제하시겠습니까?\r\n\r\n※ 삭제 시 시청기록이 함께 삭제되며,\r\n한 번 삭제된 데이터는 복구할 수 없습니다.`;
            const go = confirm(message);
            if (!go) return;

            this.$emit("remove", this.value);
        },
        updateItem(value) {
            this.$emit("updateItem", value);
        },
    },
};
</script>

<style></style>
